import React from 'react';
import { Hero } from './components/Hero';
import { WhatIs } from './components/WhatIs';
import { FocusStrip } from './components/FocusStrip';
import { WhyThis } from './components/WhyThis';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Header } from './components/Header';

function App() {
  return (
    <div className="min-h-screen bg-background selection:bg-black selection:text-white">
      <Header />
      <main>
        <Hero />
        <WhatIs />
        <FocusStrip />
        <WhyThis />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;